// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_landing__EventHandlers from "../../util/EventHandlers.js";
import * as Buhta_landing__Link from "../html/Link.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function BlogMoreTags(Props) {
  let currentTag = Props.currentTag;
  let tagsOpt = Props.tags;
  let onTagClick = Props.onTagClick;
  const tags = tagsOpt !== undefined ? tagsOpt : /* [] */ 0;
  const match = React.useState(function () {
    return false;
  });
  const setDropdownShown = match[1];
  const dropdownShown = match[0];
  const activatorRef = React.useRef(null);
  const dropdownRef = React.useRef(null);
  Buhta_landing__EventHandlers.useClickOutside(dropdownRef, activatorRef, (function (param) {
    Curry._1(setDropdownShown, (function (param) {
      return false;
    }));
  }));
  const onClickedInside = function (ev) {
    ev.stopPropagation();
    Curry._1(setDropdownShown, (function (param) {
      return !dropdownShown;
    }));
  };
  const arrowDown = StaticAsset.src("/static/icons/dropdown-down-white.svg");
  const arrowUp = StaticAsset.src("/static/icons/dropdown-up-white.svg");
  const hidden = dropdownShown ? "" : "hidden";
  const tagActive = Stdlib__List.exists((function (tag) {
    return currentTag.id === tag.id;
  }), tags) ? "bg-secondary" : "";
  return JsxRuntime.jsxs("button", {
    ref: activatorRef,
    children: [
      "Еще",
      JsxRuntime.jsx("img", {
        alt: "buhta",
        src: dropdownShown ? arrowUp : arrowDown
      }),
      JsxRuntime.jsx("div", {
        ref: dropdownRef,
        children: Belt__Belt_List.toArray(Stdlib__List.map((function (tag) {
          const Key = tag.id;
          return JsxRuntime.jsx(Buhta_landing__Link.make, {
            route: {
              TAG: /* Landing */ 0,
              _0: /* COUNTRY_KAZ */ 1,
              _1: /* Ru */ 1,
              _2: {
                TAG: /* BlogSection */ 3,
                _0: tag.title,
                _1: 0
              }
            },
            className: "paragraph-small text-black-landing px-4 py-2 text-left hover:bg-gray-pale block",
            onLinkClicked: onTagClick,
            children: tag.tag
          }, Key);
        }), tags)),
        className: "absolute top-11 -left-20 bg-white py-4 rounded-md shadow-dropdown w-40 " + hidden
      })
    ],
    className: "text-white paragraph-small px-4 py-2 border border-white/16 rounded-sm ml-2 flex relative " + tagActive,
    onClick: onClickedInside
  });
}

const make = BlogMoreTags;

export {
  make,
}
/* Buhta_landing__EventHandlers Not a pure module */
